import type { FC, PropsWithChildren } from "react";

/**
 * Wrapper which facilitates the use of grid layout for our current and legacy carousel solutions
 */
export const CarouselWidthController: FC<PropsWithChildren> = ({ children }) => (
  <div style={{ overflowX: "hidden", padding: "0 20px", margin: "0 -20px" }}>{children}</div>
);
